import staticStyles from './container.module.scss';

interface ContainerProps {
  children: React.ReactNode;
  styles?: string;
  id?: string;
}

export const Container = ({ children, styles, id }: ContainerProps) => {
  return (
    <div className={`${staticStyles.container} ${styles}`} id={id ?? ''}>
      {children}
    </div>
  );
};
